export default __webpack_public_path__ + "static/media/0.c909c3d4.png";